module.exports = __webpack_public_path__ + "static/img/school-4.48efc9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school-4.png
// module id = lRMV
// module chunks = 0